export const Actions = {
  prosFactory: {
    onClick: 'on:pros-factory:click',
    render: 'pros-factory:render:zone',
    renderProsATB: 'pros-factory:ATB:render',
    initProsFromFactory: 'pros-factory:initialize',
  },
  bopsModal: {
    onSearch: 'on:search-pdp',
    onSearchResults: 'on:search-results-pdp',
    onSearchError: 'on:search-results:error',
    onSelectStore: 'on:select-store',
    fetchStoreData: 'fetch:store:data',
    onUseCSUtil: 'on:using-csutil',
  },
  fromManufacturer: {
    load: 'webcollage:load',
    loaded: 'webcollage:loaded',
    content: {
      loaded: 'webcollage:content:loaded',
    },
  },
  sponsoredItems: {
    update: 'sponsored-items:update',
  },
  rvi: {
    render: 'rvi:render',
  },
  bazaarVoice: {
    getInstance: 'bv:get-instance',
    qaCountLoaded: 'bv:qa-count:loaded',
  },
  page: {
    redirect: 'page:redirect',
    resize: 'page:resize',
    widthRegionChange: 'page:widthRegionChange',
  },
  product: {
    accordion: {
      toggleSpecialOffers: 'product:accordion:toggle-special-offers',
      openRebateModal: 'product:accordion:open-rebate-modal',
      toggleProductDimensions: 'product:accordion:toggle-product-dimensions',
    },
    alternateImage: {
      update: 'product:alternate-image:update',
    },
    mainImageLoad: {
      onLoadComplete: 'product:main-image:on-load-complete',
    },
    swiper: {
      moving: 'product:swiper:moving',
    },
    hoverZoomer: {
      hovering: 'product:hoverZoomer:hovering',
      hoveringEnds: 'product:hoverZoomer.hoveringEnds',
    },
    styliticsWidget: {
      loaded: 'product.styliticsWidget.loaded',
      remove: 'product.styliticsWidget.remove',
      scrollTo: 'product.styliticsWidget.scrollTo',
    },
    giffWithPurchase: {
      show: 'shop:elegible:products',
    },
    bag: {
      add: 'product:bag:add',
      success: 'product:bag:success', // being used by product-details-page
    },
    zipCodeLookup: {
      updateAvailability: 'product:zip-code-lookup:update',
    },
    ctaButton: {
      showLoader: 'product:cta-button:show-loader',
      hideLoader: 'product:cta-button:hide-loader',
    },
    ctaNotification: {
      destroy: 'product:cta-notification:destroy',
      error: 'product:cta-notification:error',
      success: 'product:cta-notification:success',
      info: 'product:cta-notification:info',
    },
    masterPage: {
      showMemberItems: 'product:master:show-member-items',
      showShippingSection: 'product:master:show-shipping-returns',
      openMemberItem: 'product:master:open-member-item',
      showSelectedSizedMembers: 'product:master:show-selected-size-member-items',
    },
    customView: {
      update: 'product:custom-view:update',
    },
    list: {
      add: 'product:list:add',
      success: 'product:list:success',
    },
    mainImage: {
      update: 'product:main-image:update',
    },
    masterGrid: {
      show: 'product:master-grid:show',
    },
    registry: {
      add: 'product:registry:add',
      success: 'product:registry:success',
    },
    reviews: {
      showModal: 'product:reviews:show-modal',
      toggleReviews: 'product:reviews:toggle-reviews',
      reviewUpdated: 'product:reviews:review-updated',
      writeReview: 'product:reviews:write-review',
    },
    qa: {
      showProductQA: 'product:qa:show',
    },
    loveGallery: {
      macysLoveGallery: 'product:loveGallery:show',
    },
    store: {
      change: 'product:store:change',
    },
    video: {
      section: 'product:video:section',
      close: 'product:video:close',
      pause: 'product:video:pause',
    },
    view: {
      rendered: 'product:view:rendered',
      update: 'product:view:update', // being used by product-details-page
    },
  },
  tealium: {
    linkTag: 'tealium:link-tag',
    viewTag: 'tealium:view-tag',
  },
  header: {
    setCount: 'header:setBagCount',
  },
  addToBag: {
    showModal: 'show::modal',
  },
  reviewsPage: {
    reviewsPageLoaded: 'reviews:page:loaded',
  },
  sdd: {
    onLoadCheck: 'sdd:on:load',
  },
  hexa: {
    url: 'https://rc.hexa3d.io/product/resources?rid=205&sn=',
    dataReceived: 'hexa:dataReceived',
  },
};

export const ShopElegibleProducts = {
  enabledUrl: true,
};

export const AddToBag = {
  fromPDP: 'PDPA2B',
  addToBagUrl: '/bag/add',
  responsiveAddToBagUrl: '/xapi/bag/v1/addtobag',
  responsiveBagAddUrl: '/xapi/bag/v1/add',
  noSessionPage: '/nosessioncookie.jsp',
};

export const SignIn = {
  signinUrlFromPdp: '/account/signin?redirectUrl=/pdp/signin',
  fromReviews: '/account/myreviews?pid=',
  newReviewPage: '/shop/product/review/add',
};


export const AddToRegistry = {
  addToRegistryUrl: '/registry/wedding/additemtoregistry',
  fromPDP: 'PDPA2R',
};

export const AddToList = {
  addToListUrl: '/xapi/wishlist/v1/lists/items',
  addToListPageUrl: '/wishlist/mylist',
};

export const ApplicationMessages = {
  selection: trait => `Please select a ${trait}.`,
  availability: trait => `This ${trait} combination is not available.`,
  technicalIssue: 'Please try again, a technical issue occurred. If you continue to experience difficulties you can order by phone at 1-800-289-6229.',
  invalidZipCode: 'Please enter a valid zip code.',
  availabilityIssue: 'A technical error has occurred. To check availability, call 1-800-289-6229.',
  availabilityIssueAtr: 'This item can\'t be added to a registry.',
  shopEligibleProducts: 'Cannot show eligible products, please call 1-800-289-6229.',
};

export const BulletLinks = {
  mediaPopupUrl: filename => `/shop/media/popup/?popupFileName=${filename}`,
  productionUrl: filename => `https://www.macys.com${filename}`,
};

export const Cookies = {
  oneDayInMS: 86400000,
  thirthyDaysInMS: 2592000000,
  bagGuid: 'macys_bagguid',
  bopsPickupInStore: 'BOPSPICKUPSTORE',
  machineId: 'macys_online',
  mbox: 'mbox',
  GCs: 'GCs',
  miscGCs: 'MISCGCs',
  bvToken: 'BazaarVoiceToken',
  forwardPageKey: 'FORWARDPAGE_KEY',
  shippingCountry: 'shippingCountry',
  signedIn: 'SignedIn',
  userGuid: 'macys_online_guid',
  userId: 'macys_online_uid',
  currency: 'currency',
  bigTicketZipCode: 'BTZIPCODE',
  userPc: 'USERPC',
  csl: 'CSL',
  secureUserToken: 'secure_user_token',
  sfl: 'SFL',
  strl: 'STRL',
  ssiToken: 'SSIToken',
  adobeVistorId: 'AMCV_8D0867C25245AE650A490D4C@AdobeOrg',
  dca: 'dca',
};

export const PromoTypes = {
  rebate: 'QUALIFIES FOR REBATE',
};

export const Animation = {
  time: 300,
};

export const Zoomer = {
  maxImageWidth: 1230,
  maxImageHeight: 1500,
  params: '?op_sharpen=1&wid=1230&hei=1500&fit=fit,1&$filterxlrg$',
};

export const BreakPoints = {
  small: 600,
  medium: 1024,
  large: 1440,
};

export const OverlayDefaultDimensions = {
  width: 600,
  height: 500,
};

export const Timeouts = {
  async: 7000,
};
// NTO Local storage Timeout in Minutes
export const NTOLocalStorageTimeOut = {
  time: 15,
};

export const NTOModel = {
  offersURL: '/xapi/loyalty/v1/promotionoffers?offer=bossbops',
};

export const Review = {
  clientStoreKey: 'CSTKREV',
  feedbackValues: {
    positive: 'positive',
    negative: 'negative',
  },
  feedbackTypes: {
    reportFeedback: 'inappropriate',
    reviewFeedback: 'helpfulness',
  },
  writeReviewBottomLink: 'write_a_review-bottom',
  writeReviewTopLink: 'write_a_review-top',
  reviewsTopLink: 'read_reviews',
};

export const Rvi = {
  separator: ',',
};

export const TrueFit = {
  prod: 'https://mcy-cdn.truefitcorp.com/fitrec/mcy/js/fitrec.js?',
  qa: 'https://mcy-cdn.staging.truefitcorp.com/fitrec/mcy/js/fitrec.js?',
  dev: 'https://mcy-cdn.dev.truefitcorp.com/fitrec/mcy/js/fitrec.js?',
};

export const Findation = {
  url: 'https://assets.findation.com/javascripts/w-adv-6.min.js',
  link_name: 'pdp_find_your_shade',
  clientId: '1e6a98a7139443baf6d19c3e151b42edffefa2e54cfe89024f8d46747fac',
};

export const sddUrl = {
  buildSddUrl: productId => `/xapi/digital/v1/product/${productId}/store/bopsavailable?sddZipCode=:zipCode`,
};

export const Page = {
  // TODO: Need to calculate dynamically
  headerHeight: 198,
};

export const giftDetails = {
  quantity: [...Array(13).keys()].slice(2),
  denomination: [10, 25, 50, 75, 100, 500],
  eGiftDenomination: [10, 50, 100, 500],
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/Constants.js